module.exports = __webpack_public_path__ + "img/banner-bondholder.4f4d0d26.svg";